var isIE11 = function isIE11() {
  return typeof document !== "undefined" && !!globalThis.MSInputMethodContext && !!document.documentMode;
};

export { isIE11 };
//# sourceMappingURL=isIE11.js.map
